import { render } from "./LocationPopup.vue?vue&type=template&id=1c3e36c6&scoped=true"
import script from "./LocationPopup.vue?vue&type=script&lang=js"
export * from "./LocationPopup.vue?vue&type=script&lang=js"

import "./LocationPopup.vue?vue&type=style&index=0&id=1c3e36c6&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3e36c6"]])

export default __exports__